import { getCookie } from '@atlassian/browser-storage-controls';

// User agent checking code was copied from JFE
var DESKTOP_SWITCH_COOKIE_KEY = 'jira.mobile.desktop.switch';
var ANDROID_CHROME_USER_AGENT = /Chrome\/[.\d]* Mobile/;
var OLD_ANDROID_USER_AGENT = /Linux;(?: U;)? Android (?:[23]\.\d|4\.0\.[12])/;
var MOBILE_USER_AGENT = /(iPhone;|iPhone Simulator;|iPad;|iPod;|iPod touch;|Linux;(?: U;)? Android)/;
var IPHONE_USER_AGENT = /(iPhone;|iPhone Simulator;|iPod;|iPod touch;)/;
var IPAD_USER_AGENT = /iPad;/;
var isSupportedUserAgent = function isSupportedUserAgent() {
  var _navigator;
  if (!((_navigator = navigator) !== null && _navigator !== void 0 && (_navigator = _navigator.userAgent) !== null && _navigator !== void 0 && _navigator.length)) {
    return false;
  }
  return ANDROID_CHROME_USER_AGENT.test(navigator.userAgent) || MOBILE_USER_AGENT.test(navigator.userAgent) && !OLD_ANDROID_USER_AGENT.test(navigator.userAgent);
};
var isDesktopSwitchEnabled = function isDesktopSwitchEnabled() {
  return getCookie(DESKTOP_SWITCH_COOKIE_KEY) === 'true';
};
export function isMobile() {
  return isSupportedUserAgent() && !isDesktopSwitchEnabled();
}
export function isIPhone() {
  var _navigator2;
  if (!((_navigator2 = navigator) !== null && _navigator2 !== void 0 && (_navigator2 = _navigator2.userAgent) !== null && _navigator2 !== void 0 && _navigator2.length)) {
    return false;
  }
  return IPHONE_USER_AGENT.test(navigator.userAgent);
}
export function isIPad() {
  var _navigator3, _navigator4;
  if (!navigator || !((_navigator3 = navigator) !== null && _navigator3 !== void 0 && (_navigator3 = _navigator3.userAgent) !== null && _navigator3 !== void 0 && _navigator3.length) || !((_navigator4 = navigator) !== null && _navigator4 !== void 0 && (_navigator4 = _navigator4.platform) !== null && _navigator4 !== void 0 && _navigator4.length)) {
    return false;
  }
  var _navigator5 = navigator,
    userAgent = _navigator5.userAgent,
    platform = _navigator5.platform,
    maxTouchPoints = _navigator5.maxTouchPoints;

  // Check for iPad using user agent
  var isIPadUserGgent = IPAD_USER_AGENT.test(userAgent);

  // Check for iPad in desktop mode (iOS 13+)
  var isIPadDesktop = platform === 'MacIntel' && maxTouchPoints > 1;
  return isIPadUserGgent || isIPadDesktop;
}